export default "__VITE_ASSET__D$SDkLtP__"